import GridRoute from 'eflex/util/grid-route';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';
import { waitFor } from '@ember/test-waiters';
import { TrackedArray } from 'tracked-built-ins';

export default class LogsRoute extends GridRoute {
  @service notifier;
  @service logRepo;
  @service store;

  getData = task(waitFor(async (params = {}) => {
    return new TrackedArray(await this.store.query('log', params));
  }));

  confirmAcknowledgeLogs = task(waitFor(async () => {
    const logs = this.controller.selectedLogs;

    if (this.controller.selectAll) {
      await this.logRepo.acknowledgeAll.perform();
    } else {
      await this.logRepo.acknowledgeLogs.perform(logs);
    }

    logs.forEach(log => { log.unloadRecord(); });

    this.notifier.sendSuccess('logs.logsAcknowledged');
    await this.search.perform();
    this.controller.showAcknowledgeModal = false;
  }));
}
